export default __webpack_public_path__ + "static/pintura_industrial-0c6ecd8714128b3a668e941b33d8afee.png";